module.exports = __webpack_public_path__ + "static/media/bg_virtua.86171195.png";